export function runCallbacks(callbackArray, event) {
    const callbacks = callbackArray.slice();
    callbacks.forEach(function (callback) {
        callback(event);
    });
}
